import { get, post, patch } from 'api/request'

export const API_COMPANY = "/contact/service/company"
export const API_ACTIVITY = "/contact/service/activity"

export const getCompanyFilters = () => get(`${API_COMPANY}/counts`)
export const getCompanyFields = (fieldName) => get(`${API_COMPANY}/company_fields/${fieldName ? `?fields=${fieldName}` : ''}`)
export const getCompanyList = (listKey, offset = 0, size = 20, filters = {}, order) => {
  let params = { offset, size }
  Object.keys(filters).forEach(k => {
    params[k] = filters[k]
  })
  if (order)
    params["order"] = order
  return get(`${API_COMPANY}?group=${listKey}`, { urlParams: params })
}
export const getCompanyDetail = (key) => get(`${API_COMPANY}/${key}`)
export const updateCompany = (key, data) => patch(`${API_COMPANY}/${key}`, data)
export const createCompany = (data) => post(`${API_COMPANY}/`, data)
export const addNewOptionCompany = (fieldName, option) => post(`${API_COMPANY}/company_field_options/?field=${fieldName}`, option)
export const getCompanyActivities = (offset = 0, size = 20, filters = {}, company, group) => {
  let params = { offset, size, company, group }
  Object.keys(filters).forEach(k => {
    params[k] = filters[k]
  })
  return get(API_ACTIVITY, { urlParams: params })
}

export const uploadMediaCompany = (media, onUploadProgress = null) => {
  let formData = new FormData()
  formData.append('media', media)

  return post(`${API_COMPANY}/upload_media`, formData, { timeout: 600000, onUploadProgress })
}